import { render, staticRenderFns } from "./UserTrendFilterDefaultForm.vue?vue&type=template&id=1a3f4202"
import script from "./UserTrendFilterDefaultForm.vue?vue&type=script&lang=ts"
export * from "./UserTrendFilterDefaultForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports